import { sb } from '../../supabase.ts';

export async function renderOtherSchoolEditApplicationPage(app: HTMLElement): Promise<void> {
  const TABLE = 'student_database_others';

  app.innerHTML = `
    <style>
      .ea-wrap {
        font-family: 'Outfit', 'Segoe UI', sans-serif;
        background: radial-gradient(circle at 50% 50%, rgba(16, 185, 129, 0.05), transparent 45%), linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
        min-height: 100vh;
        color: #334155;
        padding: 24px;
        box-sizing: border-box;
      }
      .ea-header {
        max-width: 800px;
        margin: 0 auto 24px;
        text-align: center;
      }
      .ea-header h1 {
        font-size: 24px;
        color: #0f172a;
        margin: 0;
      }
      .search-box {
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.05);
        border-radius: 12px;
        padding: 24px;
        max-width: 600px;
        margin: 0 auto 24px;
        display: flex;
        gap: 12px;
        flex-direction: column;
      }
      .search-box label {
        font-size: 14px;
        font-weight: 600;
        color: #64748b;
      }
      .search-box input {
        padding: 12px 16px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        color: #0f172a;
        font-size: 16px;
        outline: none;
      }
      .search-box button {
        padding: 12px;
        background: #10b981;
        border: none;
        border-radius: 8px;
        color: #fff; font-weight: 700; cursor: pointer;
        transition: opacity 0.2s;
      }
      .search-box button:hover { opacity: 0.9; }
      
      .status {
        text-align: center;
        padding: 12px;
        margin-top: 12px;
      }
      .status.err { color: #ef4444; }
      .status.ok { color: #10b981; }

      .edit-form {
        display: none;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.08);
        border-radius: 16px;
        padding: 24px;
        max-width: 800px;
        margin: 0 auto;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
      }
      .grid {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 16px;
        margin-bottom: 24px;
      }
      .field {
        display: flex;
        flex-direction: column;
        gap: 6px;
      }
      .field label {
        font-size: 12px;
        font-weight: 600;
        color: #64748b;
      }
      .field input, .field select {
        padding: 10px 14px;
        background: #ffffff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 8px;
        color: #0f172a;
        font-size: 14px;
        outline: none;
        transition: border-color 0.2s;
      }
      .field input:focus, .field select:focus {
        border-color: #10b981;
      }
      .actions {
        display: flex;
        justify-content: flex-end;
      }
      .actions button {
        padding: 12px 24px;
        background: linear-gradient(135deg, #10b981, #059669);
        border: none;
        border-radius: 8px;
        color: #ffffff; font-weight: 700; cursor: pointer;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
        transition: opacity 0.2s;
      }
      .actions button:hover {
        opacity: 0.95;
      }
    </style>

    <div class="ea-wrap">
      <div class="ea-header">
        <a href="/other_school_dashboard" style="color:#10b981;text-decoration:none;display:block;margin-bottom:12px;">⬅ Back to Dashboard</a>
        <h1>Student Portal - Edit Application</h1>
        <p style="color:#8b949e">Update your application details before final approval.</p>
      </div>

      <div class="search-box">
        <label>Enter Birth Registration Number</label>
        <input type="text" id="searchBrc" placeholder="17-digit birth registration number..." />
        <button id="searchBtn">Find Application</button>
        <div id="searchStatus" class="status"></div>
      </div>

      <div id="editForm" class="edit-form">
        <h3 style="margin-top:0; border-bottom:1px solid rgba(0, 0, 0, 0.08); padding-bottom:12px; color: #0f172a;">Update Basic Details</h3>
        <div class="grid">
          <div class="field">
            <label>Student Name (English)</label>
            <input type="text" id="nameEn" />
          </div>
          <div class="field">
            <label>Student Name (Bangla)</label>
            <input type="text" id="nameBn" />
          </div>
          <div class="field">
            <label>Father's Name</label>
            <input type="text" id="fatherName" />
          </div>
          <div class="field">
            <label>Father's Mobile</label>
            <input type="text" id="fatherMobile" />
          </div>
          <div class="field">
            <label>Class</label>
            <select id="className">
              <option value="6">Class 6</option>
              <option value="7">Class 7</option>
              <option value="8">Class 8</option>
              <option value="9">Class 9</option>
              <option value="10">Class 10</option>
            </select>
          </div>
        </div>
        <div class="actions">
          <button id="updateBtn">Update Application</button>
        </div>
        <div id="updateStatus" class="status"></div>
      </div>
    </div>
  `;

  const searchBtn = document.getElementById('searchBtn') as HTMLButtonElement;
  const searchBrc = document.getElementById('searchBrc') as HTMLInputElement;
  const searchStatus = document.getElementById('searchStatus') as HTMLDivElement;
  
  const editForm = document.getElementById('editForm') as HTMLDivElement;
  const nameEn = document.getElementById('nameEn') as HTMLInputElement;
  const nameBn = document.getElementById('nameBn') as HTMLInputElement;
  const fatherName = document.getElementById('fatherName') as HTMLInputElement;
  const fatherMobile = document.getElementById('fatherMobile') as HTMLInputElement;
  const className = document.getElementById('className') as HTMLSelectElement;
  
  const updateBtn = document.getElementById('updateBtn') as HTMLButtonElement;
  const updateStatus = document.getElementById('updateStatus') as HTMLDivElement;
  
  let currentRecordId: number | null = null;

  searchBtn.onclick = async () => {
    const brc = searchBrc.value.trim();
    if (!brc) {
      searchStatus.className = 'status err';
      searchStatus.textContent = 'Please enter a birth registration number';
      return;
    }

    searchStatus.className = 'status';
    searchStatus.textContent = 'Searching...';
    searchBtn.disabled = true;

    try {
      const { data, error } = await sb.from(TABLE).select('*').eq('birth_registration', brc).limit(1);
      if (error) throw error;
      
      if (!data || data.length === 0) {
        searchStatus.className = 'status err';
        searchStatus.textContent = 'No application found with this registration number.';
        editForm.style.display = 'none';
      } else {
        const student = data[0];
        // If approved, lock editing
        if (['1', 'yes', 'true', 't'].includes(String(student.admission_status || '').toLowerCase())) {
          searchStatus.className = 'status err';
          searchStatus.textContent = 'Your application has been approved and can no longer be edited.';
          editForm.style.display = 'none';
        } else {
          searchStatus.className = 'status ok';
          searchStatus.textContent = 'Application found! You may update it below.';
          
          currentRecordId = student.id;
          nameEn.value = student.student_name_en || '';
          nameBn.value = student.student_name_bn || '';
          fatherName.value = student.father_name_en || '';
          fatherMobile.value = student.father_mobile || '';
          className.value = student.class_2026 || '';
          
          editForm.style.display = 'block';
        }
      }
    } catch (err: any) {
      searchStatus.className = 'status err';
      searchStatus.textContent = 'Error finding application: ' + err.message;
    } finally {
      searchBtn.disabled = false;
    }
  };

  updateBtn.onclick = async () => {
    if (!currentRecordId) return;
    
    updateStatus.className = 'status';
    updateStatus.textContent = 'Updating...';
    updateBtn.disabled = true;

    try {
      const { error } = await sb.from(TABLE).update({
        student_name_en: nameEn.value.trim(),
        student_name_bn: nameBn.value.trim(),
        father_name_en: fatherName.value.trim(),
        father_mobile: fatherMobile.value.trim(),
        class_2026: className.value
      }).eq('id', currentRecordId);

      if (error) throw error;
      
      updateStatus.className = 'status ok';
      updateStatus.textContent = 'Application successfully updated!';
    } catch (err: any) {
      updateStatus.className = 'status err';
      updateStatus.textContent = 'Failed to update: ' + err.message;
    } finally {
      updateBtn.disabled = false;
    }
  };
}
